import type { LucideIcon } from 'lucide-react';

interface AccordionItemMobileProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

const AccordionItemMobile = ({
  icon: Icon,
  title,
  description,
}: AccordionItemMobileProps) => {
  return (
    <div className="flex w-full gap-3">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-[#C8B49615]">
        <Icon className="h-4 w-4 text-accent-primary" />
      </div>
      <div className="flex flex-1 flex-col gap-0.5">
        <span className="font-body text-[13px] font-semibold text-foreground-primary">
          {title}
        </span>
        <p className="font-body text-xs leading-[1.4] text-foreground-secondary">
          {description}
        </p>
      </div>
    </div>
  );
};

export default AccordionItemMobile;
